/**
 * Which Prism this build is: the desktop IDE (default) or the public Prism
 * website (`VITE_PRISM_EDITION=website`, built into dist-website). The website
 * shows its own pages (library, account) and a trimmed IDE: no terminal, no
 * git, no native builds, no CLI providers, multiplayer through join codes only,
 * and asset jobs that run in the visitor's browser instead of on the server.
 */
export const WEBSITE = import.meta.env.VITE_PRISM_EDITION === 'website';

/**
 * Local AI (generators on this PC, local models, own keys and CLIs) is gone
 * from every build: everything runs on Prism Engine Cloud's own AI, Prisma.
 */
export const LOCAL_AI = false;
